// extracted by mini-css-extract-plugin
export var cartIcon = "_pe-0";
export var cartIconContainer = "_pe-1";